var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 50,
    viewBox: "0 0 120 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.8572 23.6803C56.9021 23.6803 57.4855 23.3048 57.4855 22.5004C57.4855 21.7491 56.9194 21.4214 55.8572 21.4214H54.7905V23.6803H55.8572ZM55.6919 20.4734C56.6843 20.4734 57.1066 20.0849 57.1066 19.4642C57.1066 18.7737 56.6407 18.5114 55.7181 18.5114H54.7905V20.4734H55.6919ZM53.5278 17.5244H55.805C57.2677 17.5244 58.3433 17.9745 58.3433 19.2853C58.3433 19.9577 57.9776 20.6133 57.355 20.8321V20.8756C58.1429 21.0545 58.7219 21.6051 58.7219 22.5705C58.7219 23.9997 57.555 24.6676 55.9877 24.6676H53.5278V17.5244Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.59 17.5234H60.8526V24.667H59.59V17.5234Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.822 23.6403C65.2544 23.6403 66.0774 22.8233 66.0774 21.0668C66.0774 19.3107 65.2544 18.5501 63.822 18.5501H63.2692V23.6403H63.822ZM62.0066 17.5234H63.9048C66.0863 17.5234 67.3748 18.7033 67.3748 21.0668C67.3748 23.4307 66.0863 24.667 63.9703 24.667H62.0066V17.5234Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.5526 18.5904H69.4976V17.5244H74.8702V18.5904H72.8152V24.668H71.5526V18.5904Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.6233 17.5234H76.8859V20.3941H79.764V17.5234H81.0266V24.667H79.764V21.4994H76.8859V24.667H75.6233V17.5234Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.1865 17.5234H83.4492V24.667H82.1865V17.5234Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.1156 23.7521L84.8514 22.8827C85.3609 23.3696 86.0445 23.6972 86.706 23.6972C87.5072 23.6972 87.9472 23.3328 87.9472 22.7755C87.9472 22.1878 87.4876 22 86.8413 21.7244L85.8681 21.3007C85.1671 21.0083 84.4291 20.451 84.4291 19.4069C84.4291 18.2686 85.4304 17.3926 86.8195 17.3926C87.651 17.3926 88.4563 17.7377 89.0139 18.3035L88.365 19.1075C87.9124 18.7209 87.4288 18.4938 86.8195 18.4938C86.1447 18.4938 85.7047 18.8106 85.7047 19.3324C85.7047 19.8941 86.2468 20.1015 86.8369 20.3441L87.7967 20.7482C88.6438 21.1021 89.2357 21.6394 89.2357 22.675C89.2357 23.833 88.2781 24.7984 86.6801 24.7984C85.7177 24.7984 84.7907 24.4184 84.1156 23.7521Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.7089 31.8146C56.7712 31.8146 57.2766 31.3909 57.2766 30.513C57.2766 29.6258 56.7235 29.3242 55.6653 29.3242H54.7905V31.8146H55.7089ZM53.5278 28.3105H55.7699C57.3502 28.3105 58.5215 28.8612 58.5215 30.513C58.5215 32.1055 57.3461 32.8283 55.8136 32.8283H54.7905V35.4544H53.5278V28.3105Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.0234 32.4777L64.7255 35.4541H63.3064L61.7743 32.6621L63.0234 32.4777ZM61.6951 31.6484C62.6705 31.6484 63.2018 31.2424 63.2018 30.4295C63.2018 29.6081 62.6705 29.3242 61.6951 29.3242H60.6894V31.6484H61.6951ZM59.4268 28.3105H61.826C63.3064 28.3105 64.447 28.8348 64.447 30.4295C64.447 31.5137 63.8786 32.1797 63.0234 32.4777C62.6672 32.6018 62.2613 32.6621 61.826 32.6621H61.7743H60.6894V35.4541H59.4268V28.3105Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.0417 31.8541C70.0417 30.2505 69.3192 29.2809 68.2003 29.2809C67.0811 29.2809 66.3586 30.2505 66.3586 31.8541C66.3586 33.4576 67.0811 34.4843 68.2003 34.4843C69.3192 34.4843 70.0417 33.4576 70.0417 31.8541ZM65.0609 31.8541C65.0609 29.5429 66.3454 28.1797 68.2003 28.1797C70.0549 28.1797 71.3391 29.5492 71.3391 31.8541C71.3391 34.1656 70.0549 35.5855 68.2003 35.5855C66.3454 35.5855 65.0609 34.1656 65.0609 31.8541Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.2998 31.8146C75.362 31.8146 75.8674 31.3909 75.8674 30.513C75.8674 29.6258 75.3143 29.3242 74.2562 29.3242H73.3813V31.8146H74.2998ZM72.1187 28.3105H74.3608C75.9411 28.3105 77.1124 28.8612 77.1124 30.513C77.1124 32.1055 75.937 32.8283 74.4044 32.8283H73.3813V35.4544H72.1187V28.3105Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.0178 28.3105H82.3023V29.3766H79.2805V31.2076H81.8405V32.2735H79.2805V34.3881H82.4107V35.4541H78.0178V28.3105Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.0348 32.4777L88.7368 35.4541H87.3177L85.7856 32.6621L87.0348 32.4777ZM85.7065 31.6484C86.6818 31.6484 87.2131 31.2424 87.2131 30.4295C87.2131 29.6081 86.6818 29.3242 85.7065 29.3242H84.7008V31.6484H85.7065ZM83.4381 28.3105H85.8373C87.3177 28.3105 88.4584 28.8348 88.4584 30.4295C88.4584 31.5137 87.8899 32.1797 87.0348 32.4777C86.6786 32.6018 86.2726 32.6621 85.8373 32.6621H85.7856H84.7008V35.4541H83.4381V28.3105Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.7092 29.3766H88.6542V28.3105H94.0268V29.3766H91.9718V35.4541H90.7092V29.3766Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.4261 32.7975L94.2842 28.3105H95.6337L96.4087 30.1368C96.6176 30.6677 96.818 31.1638 97.0421 31.7074H97.0857C97.3101 31.1638 97.5342 30.6677 97.7409 30.1368L98.5159 28.3105H99.8307L97.6888 32.7975V35.4541H96.4261V32.7975Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5326 40.7125H41.9446C43.9712 40.7125 45.6143 39.0639 45.6143 37.0299V16.3998C45.6143 15.1019 44.9336 13.9002 43.8226 13.236L28.4881 4.06959C27.331 3.37785 25.8892 3.37785 24.7321 4.06959L9.39793 13.236C8.28667 13.9002 7.6062 15.1019 7.6062 16.3998V46.8649L15.4302 41.3766C16.0465 40.9443 16.7807 40.7125 17.5326 40.7125ZM28.0719 17.2407H25.1484V14.3066H28.0719V17.2407ZM19.301 31.9107H16.3771V23.1087H19.301V31.9107ZM16.3771 20.1749V17.2408H13.4536V34.8445H22.2245V20.1749H16.3771ZM36.8432 31.9107H33.9193V23.1087H36.8432V31.9107ZM36.8432 17.2408V20.1749H30.9958V34.8445H39.7667V17.2408H36.8432ZM25.1484 34.8444H28.0719V20.1745H25.1484V34.8444Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.9784523a83490273ddbdcb60e499d44b.svg";
export { ForwardRef as ReactComponent };